import { Suspense, lazy, useEffect, useState } from "react";
import { Navigate, useLocation, Routes, Route } from "react-router-dom";
// layouts
import DashboardLayout from "../layouts/dashboard";
// components
import LoadingScreen from "../components/LoadingScreen";
import Protected from "./Protected";
import UnProtected from "./UnProtected";
import useDetails from "src/hooks/useDetails";
import EditDocBasicinfo from "src/pages/Doctors/EditDocBasicinfo";
import NewCarePlan_Doctor from "src/pages/CarePlan_Doctor/NewCarePlan_Doctor";
import EditCarePlan_Doctor from "src/pages/CarePlan_Doctor/EditCarePlan_Doctor";
import Appointments_Doctor from "src/pages/Appointments_Doctor/Appointments_Doctor";
// import DoctorDashboard from "src/pages/AppointmentScheduler/DoctorsDashboard";
import Appointments_Patient from "src/pages/Appointments_Patient/Appointments_Patient";
import Patients_Doctor from "src/pages/Patient_Doctor/Patients_Doctor";
import PatientsEditStepper_Doctor from "src/pages/Patient_Doctor/PatientsEditStepper_Doctor";
import PatientVitalsLog from "src/pages/PatientsDasboard/MyProfile/PatientVitalsLog";
import CaregiverPatientVitalsLog from "src/pages/CaregiverDasboard/MyProfile/PatientVitalsLog";
import AddVitals from "src/pages/PatientsDasboard/AddVitals";
import CaregiverAddVitals from "src/pages/CaregiverDasboard/AddVitals";
import PatientVitals_Doctor from "src/pages/PatientVitals/PatientVitals_Doctor";
import CompletedForms from "src/pages/PatientsDasboard/MyProfile/CompletedForms";
import CaregiverCompletedForms from "src/pages/CaregiverDasboard/MyProfile/CompletedForms";
import ReportIssue from "src/pages/Login/ReportIssue";
import ReportIssueEdit from "src/pages/Login/ReportIssueEdit";
import ReportIssueView from "src/pages/Login/ReportIssueView";
import ReportNotification from "src/pages/Login/ReportNotification";
//Programs
import AssignProgram from "src/pages/Programs/AssignProgram";
import AddPrograms from "src/pages/Programs/AddProgram";
import ProgramForms from "src/pages/Programs/CreateProgram";
import EditProgram from "src/pages/Programs/EditProgram";
import NewProgram from "src/pages/Programs/NewProgram";
import HampView from "src/pages/Forms/HampView";
import ActivityLog from "src/pages/Login/ActivityLog";
//Create Password for Patient
import CreatePassword from "../pages/Login/CreatePassword";
import Patient from "src/pages/PatientRegistration/AddPatient/Patient";
// import PatientDashboard from "src/pages/AppointmentScheduler/PatientsDashboard";
import PatientAppointmentsPage from "src/pages/AppointmentScheduler/PatientAppointmentsPage";
import DoctorDashboard from "src/pages/AppointmentScheduler/DoctorAppointmentsPage";

// import PatientsEditStepper_Careadmin from "src/pages/Patient_CareAdmin/PatientsEditStepper_Careadmin";
// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  return (
    <Suspense
      fallback={<LoadingScreen isDashboard={pathname.includes("dashboard")} />}
    >
      <Component {...props} />
    </Suspense>
  );
};

const redirectionFn = (
  providePaths,
  local_url,
  component,
  pageType = "Found"
) => {
  return providePaths.map((providePath) => {
    providePath = providePath.split("/");
    return (pageType =
      "Found" && local_url === providePath ? (
        <Route path={providePath[0]}>
          <Route index element={<Navigate to={providePath[1]} />} />
          <Route path={local_url} element={component} />
        </Route>
      ) : (
        <Route path={providePath[0]}>
          <Route index element={<Navigate to={providePath[1]} />} />
          <Route path={local_url} element={<Unauthorized />} />
        </Route>
      ));
  });
};

const redirectPathsArr = [
  "patientmonitoring/questionnairesassignment",
  "user/users",
  "email/sendemail",
];

const getDashboardURLByRole = {
  "guest doctor": "doctordashboard",
  "patient guardian": "patientguardiandashboard",
  "care admin": "maindashboard",
  provider: "doctordashboard",
  patient: "patientdashboard",
  insurance: "insurancedashboard",
  "care admin manager": "maindashboard",
  developer: "developerdashboard",
};
const DynamicRoutes = (List) => {
  const details = useDetails();
  // console.log(details.rolesname[0],"details")
  return PATHS.map(({ local_url, remote_url, component }, ind) => {
    if (List.includes(remote_url)) {
      return (
        <Route key={ind} element={<DashboardLayout />}>
          <Route path="dashboard">
            {redirectionFn(redirectPathsArr, local_url, component)}
            <Route
              index
              element={
                <Navigate
                  to={
                    getDashboardURLByRole[details?.rolesname[0].toLowerCase()]
                  }
                />
              }
            />
            <Route path={local_url} element={component} />
          </Route>
        </Route>
      );
    } else {
      return (
        <Route path="dashboard" key={ind}>
          {redirectionFn(redirectPathsArr, local_url, component, "NotFound")}
          <Route index path={local_url} element={<Unauthorized />} />
        </Route>
      );
    }
  });
};

export default function Router() {
  const location = useLocation();
  const details = useDetails();

  return (
    <Routes>
      <Route path="/">
        <Route element={<UnProtected />}>
          <Route path="login" element={<LoginForm />} />
          <Route path="forgotpassword" element={<ForgotPass />} />
          <Route path="createpassword" element={<CreatePassword />} />
          <Route path="resetpassword1/:hash" element={<ResetPassword1 />} />
        </Route>
        <Route index element={<Navigate to="dashboard" />} />

        <Route element={<Protected />}>
          {DynamicRoutes(details?.permission ? details?.permission : [])}
        </Route>
      </Route>

      <Route path="/404" element={<PageNotFound />} />
      <Route path="/unauthorized" element={<Unauthorized />} />

      <Route
        path="*"
        element={<Navigate to="/404" state={{ from: location }} replace />}
      />
    </Routes>
  );
}
const MyProfile = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile"))
);
const CaregiverPatientProfile = Loadable(
  lazy(() => import("../pages/CaregiverDasboard/MyProfile"))
);
//PHQ8
const Phq8Tmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Phq8")));
const Phq8 = Loadable(lazy(() => import("../pages/Forms/Phq8")));
const Phq8View = Loadable(lazy(() => import("../pages/Forms_Careadmin/Phq8")));
const MyProfileCareadmin = Loadable(
  lazy(() =>
    import(
      "../pages/Patient_CareAdmin/PatientProfile_Careadmin/PatientProfile_Careadmin"
    )
  )
);
const MyProfileDoctor = Loadable(
  lazy(() =>
    import(
      "../pages/Patient_Doctor/PatientProfile_Doctor/PatientProfile_Doctor"
    )
  )
);
// Dashboard
const PageOne = Loadable(lazy(() => import("../pages/PageOne")));
const PageOne_insurance = Loadable(
  lazy(() => import("../pages/PageOne_insurance"))
);
const PageOne_patients = Loadable(
  lazy(() => import("../pages/PageOne_patients"))
);
const PageOne_doctor = Loadable(lazy(() => import("../pages/PageOne_doctor")));
const PageOne_guardian = Loadable(
  lazy(() => import("../pages/PageOne_guardian"))
);
const KaizenExplore = Loadable(lazy(() => import("../pages/KaizenExplore")));

const AdhdCdss = Loadable(lazy(() => import("../pages/CDSS/AdhdhCdss")));
const TbiCdss = Loadable(lazy(() => import("../pages/TBI_CDSS/TbiCdss")));
const HeadacheCdss = Loadable(
  lazy(() => import("../pages/Headache_CDSS/HeadacheCdss"))
);
const MemoryCdss = Loadable(
  lazy(() => import("../pages/Memory_CDSS/MemoryCdss"))
);

const ChatScreen = Loadable(lazy(() => import("../pages/Chat/ChatScreen")));

const ConcussionPrediction = Loadable(
  lazy(() => import("../pages/ConcussionPrediction"))
);
const PatientProfile = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile/PatientProfile"))
);
const ProfileCover = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile/ProfileCover"))
);
const PatientFormList = Loadable(
  lazy(() => import("../pages/PatientsDasboard/PatientFormList"))
);
const PatientClinicalNotes = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile/PatientClinicalNotes"))
);
const Documents = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile/Documents"))
);
const PatientAppointments = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile/PatientAppointments"))
);
const PatientCarePlan = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile/PatientCarePlan"))
);
const PatientDetails = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile/PatientDetails"))
);
const PatientInfo = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile/PatientInfo"))
);
const PatientInvoices = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile/PatientInvoices"))
);
const PatientsEdit = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile/PatientDetails"))
);
const PatientSendEmail = Loadable(
  lazy(() => import("../pages/PatientsDasboard/MyProfile/PatientSendEmail"))
);

const PatientBasicInfo = Loadable(
  lazy(() =>
    import(
      "../pages/PatientsDasboard/MyProfile/PatientDetails/PatientBasicInfo"
    )
  )
);
const PatientCounter = Loadable(
  lazy(() =>
    import("../pages/PatientsDasboard/MyProfile/PatientDetails/PatientCounter")
  )
);
const PatientCreditPolicy = Loadable(
  lazy(() =>
    import(
      "../pages/PatientsDasboard/MyProfile/PatientDetails/PatientCreditPolicy"
    )
  )
);
const PatientDoctorProvider = Loadable(
  lazy(() =>
    import(
      "../pages/PatientsDasboard/MyProfile/PatientDetails/PatientDoctorProvider"
    )
  )
);
const PatientEmergency = Loadable(
  lazy(() =>
    import(
      "../pages/PatientsDasboard/MyProfile/PatientDetails/PatientEmergency"
    )
  )
);
const PatientFinancial = Loadable(
  lazy(() =>
    import(
      "../pages/PatientsDasboard/MyProfile/PatientDetails/PatientFinancial"
    )
  )
);
const PatientHealthProvider = Loadable(
  lazy(() =>
    import(
      "../pages/PatientsDasboard/MyProfile/PatientDetails/PatientHealthProvider"
    )
  )
);
const PatientHipaa = Loadable(
  lazy(() =>
    import("../pages/PatientsDasboard/MyProfile/PatientDetails/PatientHipaa")
  )
);
const PatientInsuranceInformation = Loadable(
  lazy(() =>
    import(
      "../pages/PatientsDasboard/MyProfile/PatientDetails/PatientInsuranceInformation"
    )
  )
);
const PatientMedication = Loadable(
  lazy(() =>
    import(
      "../pages/PatientsDasboard/MyProfile/PatientDetails/PatientMedication"
    )
  )
);
const PatientPrescription = Loadable(
  lazy(() =>
    import(
      "../pages/PatientsDasboard/MyProfile/PatientDetails/PatientPrescription"
    )
  )
);

// Patient Registration
const PatientRegistration = Loadable(
  lazy(() => import("../pages/PatientRegistration/PatientRegistration"))
);
const AddPatient = Loadable(
  lazy(() => import("../pages/PatientRegistration/Addpatient"))
);
// const AssignDoctor = Loadable(
//   lazy(() => import("../pages/PatientRegistration/AssignDoctor"))
// );
// const InsuranceInformation = Loadable(
//   lazy(() => import("../pages/PatientRegistration/InsuranceInformation"))
// );
// const AddingPatient = Loadable(
//   lazy(() => import("../pages/PatientRegistration/AddingPatient"))
// );
const EditingPatient = Loadable(
  lazy(() => import("../pages/PatientRegistration/EditingPatient"))
);

// Insurance
const Insurance = Loadable(lazy(() => import("../pages/Insurance/Insurance")));
const InsuranceInformation1 = Loadable(
  lazy(() => import("../pages/Insurance/InsuranceInformation1"))
);
const PersonalInfo = Loadable(
  lazy(() => import("../pages/Insurance/PersonalInfo"))
);
// const EditInsuranceInfo = Loadable(
//   lazy(() => import("../pages/Insurance/EditInsuranceInfo"))
// );
// const EditPersonalInfo = Loadable(
//   lazy(() => import("../pages/Insurance/EditPersonalInfo"))
// );

// Patients
const AddPatient1 = Loadable(
  lazy(() => import("../pages/Patient/Addpatient1"))
);
const PatientsMainStepper = Loadable(
  lazy(() => import("../pages/Patient/PatientsMainStepper"))
);
const PatientsEditStepper = Loadable(
  lazy(() => import("../pages/Patient/PatientsEditStepper"))
);
const CaregiverPatientsEditStepper = Loadable(
  lazy(() => import("../pages/CaregiverPatient/PatientsEditStepper"))
);
const PatientInsuranceInfo = Loadable(
  lazy(() => import("../pages/Patient/PatientInsuranceInfo"))
);
const InsuranceStepper = Loadable(
  lazy(() => import("../pages/Insurance/InsuranceStepper"))
);
const Agreement = Loadable(lazy(() => import("../pages/Patient/Agreement")));
const Consent = Loadable(lazy(() => import("../pages/Patient/Consent")));
const Emergency = Loadable(lazy(() => import("../pages/Patient/Emergency")));
const Financial = Loadable(lazy(() => import("../pages/Patient/Financial")));
const HealthProvider = Loadable(
  lazy(() => import("../pages/Patient/HealthProvider"))
);
const Hipaa = Loadable(lazy(() => import("../pages/Patient/Hipaa")));
const InsInfo = Loadable(lazy(() => import("../pages/Patient/InsInfo")));
const Medications = Loadable(
  lazy(() => import("../pages/Patient/Medications"))
);
const NonPrescription = Loadable(
  lazy(() => import("../pages/Patient/NonPrescription"))
);
const Patients = Loadable(lazy(() => import("../pages/Patient/Patients")));
const Prescription = Loadable(
  lazy(() => import("../pages/Patient/Prescription"))
);

//Patient_CareAdmin
const Patients_Careadmin = Loadable(
  lazy(() => import("../pages/Patient_CareAdmin/Patients_Careadmin"))
);
const PatientsEditStepper_Careadmin = Loadable(
  lazy(() => import("../pages/Patient_CareAdmin/PatientsEditStepper_Careadmin"))
);

// Patient Monitoring
const QuestionnairesAssignment = Loadable(
  lazy(() => import("../pages/PatientMonitoring/QuestionnairesAssignment"))
);
const TmpHistory = Loadable(
  lazy(() => import("../pages/PatientMonitoring/TmpHistory"))
);
const TmpGraph = Loadable(
  lazy(() => import("../pages/PatientMonitoring/TmpGraph"))
);
const TrmGraph = Loadable(
  lazy(() => import("../pages/PatientMonitoring/TrmGraph"))
);
const KhpGraph = Loadable(
  lazy(() => import("../pages/PatientMonitoring/KhpGraph"))
);
const AdhdGraph = Loadable(
  lazy(() => import("../pages/PatientMonitoring/AdhdGraph"))
);
const SaintGraph = Loadable(
  lazy(() => import("../pages/PatientMonitoring/SaintGraph"))
);
const KmpGraph = Loadable(
  lazy(() => import("../pages/PatientMonitoring/KmpGraph"))
);
const TmpQuestionnaires = Loadable(
  lazy(() => import("../pages/PatientMonitoring/TmpQuestionnaires"))
);
const BdiTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Bdi")));
const HitTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Hit")));
const RpcsTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Rpcs")));
const EssTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Ess")));
const CissTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Ciss")));
const NpiTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Npi")));
// const RpcsTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Rpcs")));
const GadTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Gad")));
const PhqTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Phq")));
const QolTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/StigmaForm"))
);
const LawtonTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/Lawton"))
);
const ActivitiesFormTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/ActivitiesForm"))
);
// const AdhdTmp = Loadable(lazy(()=>import("../pages/PatientMonitoring/Adhd_old")));
const AdhdTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Adhd")));
const SunshineTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/SunshineAct"))
);
const HipaaRfTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/Hipaa2"))
);
const HipaaNppTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/HipaaN"))
);
const CaicTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Caic")));
const IcnaTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/NeuroConsent"))
);
const CpcrTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Cpcr")));
const MbTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Mb")));
const MedicalTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/Medical"))
);
const MnaTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Mna")));
const FpqTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/FacialPain"))
);
const NphqTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Nphq")));
const DsrsFormTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/DsrsForm"))
);
const SafetyTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/Safety"))
);
const FaqTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/Faq")));
const NasaTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/NasaForm"))
);
const StressMeterTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/StressMeter"))
);

const Bdi = Loadable(lazy(() => import("../pages/Forms/Bdi")));
const Ciss = Loadable(lazy(() => import("../pages/Forms/Ciss")));
const Ess = Loadable(lazy(() => import("../pages/Forms/Ess")));
const Hit = Loadable(lazy(() => import("../pages/Forms/Hit")));
const Lawton = Loadable(lazy(() => import("../pages/Forms/Lawton")));
const Mb = Loadable(lazy(() => import("../pages/Forms/Mb")));
const Medical = Loadable(lazy(() => import("../pages/Forms/Medical")));
const Mna = Loadable(lazy(() => import("../pages/Forms/Mna")));
const Nphq = Loadable(lazy(() => import("../pages/Forms/Nphq")));
const Npi = Loadable(lazy(() => import("../pages/Forms/Npi")));
const Phq = Loadable(lazy(() => import("../pages/Forms/Phq")));
const Rpcs = Loadable(lazy(() => import("../pages/Forms/Rpcs")));
const Phqtrm = Loadable(lazy(() => import("../pages/Forms/Phqtrm")));
const Gadtrm = Loadable(lazy(() => import("../pages/Forms/Gadtrm")));
const Rpcstrm = Loadable(lazy(() => import("../pages/Forms/Rpcstrm")));
const Hittrm = Loadable(lazy(() => import("../pages/Forms/Hittrm")));
const Esstrm = Loadable(lazy(() => import("../pages/Forms/Esstrm")));
const Cisstrm = Loadable(lazy(() => import("../pages/Forms/Cisstrm")));
const RpcstrmTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/Rpcstrm"))
);
const HittrmTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/Hittrm"))
);
const EsstrmTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/Esstrm"))
);
const CisstrmTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/Cisstrm"))
);
const PhqtrmView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/Phqtrm"))
);
const GadtrmView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/Gadtrm"))
);
const GadtrmTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/Gadtrm"))
);
const PhqtrmTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/Phqtrm"))
);
const RpcstrmView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/Rpcstrm"))
);
const HittrmView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/Hittrm"))
);
const EsstrmView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/Esstrm"))
);
const CisstrmView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/Cisstrm"))
);
//Diagnostic Reports
const DiagnosticUpload = Loadable(
  lazy(() => import("../pages/PatientMonitoring/DiagnosticUpload"))
);
const DiagnosticView = Loadable(
  lazy(() => import("../pages/PatientMonitoring/DiagnosticView"))
);

// Forms View
const RpcsView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Rpcs")));
const HitView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Hit")));
const StressView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/StressMeter"))
);
const NpioView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/Npi/NpiOriginal"))
);
const DsrsView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/DsrsForm"))
);
const SafetyView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/Safety"))
);
const FaqView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Faq")));
const NasaView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/NasaForm"))
);

const BdiView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Bdi")));
const NpiView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Npi")));
const EssView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Ess")));
const CissView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Ciss")));
const MedicalView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/Medical"))
);
const PhqView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Phq")));
const NphqView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Nphq")));
const GadView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Gad")));
const MnaView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Mna")));
const MbView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Mb")));
const LawtonView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/Lawton"))
);
const FacialPainView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/FacialPain"))
);
const AdhdView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Adhd")));
const HippaView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/Hipaa2"))
);
const HipaaNppView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/HipaaN"))
);
const SunshineActView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/SunshineAct"))
);
const NeuroConsentView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/NeuroConsent"))
);
const CpcrView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Cpcr")));
const CaicView = Loadable(lazy(() => import("../pages/Forms_Careadmin/Caic")));
const ActivitiesFormView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/ActivitiesForm"))
);
const StigmaFormView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/StigmaForm"))
);
const DrFoxView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/DrFox"))
);
const OxfordView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/OxfordForm"))
);
const PclView = Loadable(lazy(() => import("../pages/Forms_Careadmin/PCL5")));
const NeuroQolView = Loadable(
  lazy(() => import("../pages/Forms_Careadmin/NeuroQol"))
);

const DsrsForm = Loadable(lazy(() => import("../pages/Forms/Dsrsform")));
const Safety = Loadable(lazy(() => import("../pages/Forms/Safety")));
const Faq = Loadable(lazy(() => import("../pages/Forms/Faq")));
const Nasa = Loadable(lazy(() => import("../pages/Forms/NasaForm")));
const StressMeter = Loadable(lazy(() => import("../pages/Forms/StressMeter")));

const Pcl = Loadable(lazy(() => import("../pages/Forms/PCL5")));
const OxfordForm = Loadable(lazy(() => import("../pages/Forms/OxfordForm")));
const NeuroQol = Loadable(lazy(() => import("../pages/Forms/NeuroQol")));
const PclTmp = Loadable(lazy(() => import("../pages/PatientMonitoring/PCL5")));
const OxfordTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/OxfordForm"))
);
const NeuroQolTmp = Loadable(
  lazy(() => import("../pages/PatientMonitoring/NeuroQol"))
);

// Pending Forms
const PendingForms = Loadable(
  lazy(() => import("../pages/PendingForms/PendingForms"))
);

// All Patient Vitals
const PatientVitals = Loadable(
  lazy(() => import("../pages/PatientVitals/PatientVitals"))
);
const AddPatientVitals = Loadable(
  lazy(() => import("../pages/PatientVitals/AddPatientVitals"))
);

const HampInsert = Loadable(lazy(() => import("../pages/Forms/HampInsert")));

// Appointments
const Appointments = Loadable(
  lazy(() => import("../pages/Appointments/Appointments"))
);
const NewAppointment = Loadable(
  lazy(() => import("../pages/Appointments/NewAppointment"))
);
const EditAppointment = Loadable(
  lazy(() => import("../pages/Appointments/EditAppointment"))
);

// Care Plan
const CarePlan = Loadable(lazy(() => import("../pages/CarePlan/CarePlan")));
const CarePlan_Doctor = Loadable(
  lazy(() => import("../pages/CarePlan_Doctor/CarePlan_Doctor"))
);
const NewCarePlan = Loadable(
  lazy(() => import("../pages/CarePlan/NewCarePlan"))
);
const EditCarePlan = Loadable(
  lazy(() => import("../pages/CarePlan/EditCarePlan"))
);

// Departments
const Departments = Loadable(
  lazy(() => import("../pages/Department/Departments"))
);
const NewDepartments = Loadable(
  lazy(() => import("../pages/Department/NewDepartments"))
);
const EditDepartments = Loadable(
  lazy(() => import("../pages/Department/EditDepartment"))
);

// Doctors
const AddDoctor = Loadable(lazy(() => import("../pages/Doctors/AddDoctor")));
const EditDoctor = Loadable(lazy(() => import("../pages/Doctors/EditDoctor")));
const DocAddress = Loadable(lazy(() => import("../pages/Doctors/DocAddress")));
const DocAppointmentinfo = Loadable(
  lazy(() => import("../pages/Doctors/DocAppointmentinfo"))
);

// const ResetPassword = Loadable(
//   lazy(() => import("../pages/Email/ResetPassword"))
// );

const DocBasicinfo = Loadable(
  lazy(() => import("../pages/Doctors/DocBasicinfo"))
);
const DocHolidays = Loadable(
  lazy(() => import("../pages/Doctors/DocHolidays"))
);
const Doctors = Loadable(lazy(() => import("../pages/Doctors/Doctors")));
const DocWebdata = Loadable(lazy(() => import("../pages/Doctors/DocWebdata")));

// User
const AddAddress = Loadable(lazy(() => import("../pages/User/AddAddress")));
const AddBasicinfo = Loadable(lazy(() => import("../pages/User/AddBasicinfo")));
const AddUser = Loadable(lazy(() => import("../pages/User/AddUser")));
const EditUser = Loadable(lazy(() => import("../pages/User/EditUser")));
const ListOfPassword = Loadable(
  lazy(() => import("../pages/User/ListOfPassword"))
);
const EditListOfPassword = Loadable(
  lazy(() => import("../pages/User/EditListOfPassword"))
);
const NewUserRole = Loadable(lazy(() => import("../pages/User/NewUserRole")));
const EditUserRole = Loadable(lazy(() => import("../pages/User/EditUserRole")));
const UserRole = Loadable(lazy(() => import("../pages/User/UserRole")));
const Users = Loadable(lazy(() => import("../pages/User/Users")));

// Forms
const ActivitiesForm = Loadable(
  lazy(() => import("../pages/Forms/ActivitiesForm"))
);
const Adhd = Loadable(lazy(() => import("../pages/Forms/Adhd")));
const AssignForms = Loadable(lazy(() => import("../pages/Forms/AssignForms")));
const EditAssignedForms = Loadable(
  lazy(() => import("../pages/Forms/EditAssignedForms"))
);
const Caic = Loadable(lazy(() => import("../pages/Forms/Caic")));
const Cpcr = Loadable(lazy(() => import("../pages/Forms/Cpcr")));
const FacialPain = Loadable(lazy(() => import("../pages/Forms/FacialPain")));
const Forms = Loadable(lazy(() => import("../pages/Forms/Forms")));
const Gad = Loadable(lazy(() => import("../pages/Forms/Gad")));
const StigmaForm = Loadable(lazy(() => import("../pages/Forms/StigmaForm")));
const SunshineAct = Loadable(lazy(() => import("../pages/Forms/SunshineAct")));
const NeuroConsent = Loadable(
  lazy(() => import("../pages/Forms/NeuroConsent"))
);
const NewForm = Loadable(lazy(() => import("../pages/Forms/NewForm")));
const Hipaa2 = Loadable(lazy(() => import("../pages/Forms/Hipaa2")));
const HipaaNP = Loadable(lazy(() => import("../pages/Forms/HipaaN")));
const DrFox = Loadable(lazy(() => import("../pages/Forms/DrFox")));

// Email
const CareGiver = Loadable(lazy(() => import("../pages/Email/CareGiver")));
const EmailLog = Loadable(lazy(() => import("../pages/Email/EmailLog")));
const EmailSettings = Loadable(
  lazy(() => import("../pages/Email/EmailSettings"))
);
const EmailTemplate = Loadable(
  lazy(() => import("../pages/Email/EmailTemplate"))
);
// const ForgotPassword = Loadable(
//   lazy(() => import("../pages/Email/ForgotPassword"))
// );
// Reset Password
const ResetPassword1 = Loadable(
  lazy(() => import("../pages/Login/ResetPassword1"))
);
const NewAdmin = Loadable(lazy(() => import("../pages/Email/NewAdmin")));
const NewAppointment1 = Loadable(
  lazy(() => import("../pages/Email/NewAppointment1"))
);
const NewInvoice = Loadable(lazy(() => import("../pages/Email/NewInvoice")));
const NewPatient = Loadable(lazy(() => import("../pages/Email/NewPatient")));
const NewRequest = Loadable(lazy(() => import("../pages/Email/NewRequest")));
const NewWebsite = Loadable(lazy(() => import("../pages/Email/NewWebsite")));
const PaymentConfirmation = Loadable(
  lazy(() => import("../pages/Email/PaymentConfirmation"))
);
// const ResetPassword = Loadable(
//   lazy(() => import("../pages/Email/ResetPassword"))
// );
const SendBulkEmail = Loadable(
  lazy(() => import("../pages/Email/SendBulkEmail"))
);
const SendEmail = Loadable(lazy(() => import("../pages/Email/SendEmail")));

// Settings
const Address = Loadable(lazy(() => import("../pages/Settings/Address")));
const BasicInfo = Loadable(lazy(() => import("../pages/Settings/BasicInfo")));
const ClinicalNotes = Loadable(
  lazy(() => import("../pages/Settings/ClinicalNotes"))
);
const ExpenseType = Loadable(
  lazy(() => import("../pages/Settings/ExpenseType"))
);
const InvoiceItems = Loadable(
  lazy(() => import("../pages/Settings/InvoiceItems"))
);
const NewExpense = Loadable(lazy(() => import("../pages/Settings/NewExpense")));
const NewItem = Loadable(lazy(() => import("../pages/Settings/NewItem")));
const NewNote = Loadable(lazy(() => import("../pages/Settings/NewNote")));
const NewPayment = Loadable(lazy(() => import("../pages/Settings/NewPayment")));
const NewSupplier = Loadable(
  lazy(() => import("../pages/Settings/NewSupplier"))
);
const NewTax = Loadable(lazy(() => import("../pages/Settings/NewTax")));
const PaymentGateway = Loadable(
  lazy(() => import("../pages/Settings/PaymentGateway"))
);
const PaymentMethod = Loadable(
  lazy(() => import("../pages/Settings/PaymentMethod"))
);
const SocialLink = Loadable(lazy(() => import("../pages/Settings/SocialLink")));
const Suppliers = Loadable(lazy(() => import("../pages/Settings/Suppliers")));
const SystemInfo = Loadable(lazy(() => import("../pages/Settings/SystemInfo")));
const TaxRate = Loadable(lazy(() => import("../pages/Settings/TaxRate")));

// Blog
const Blog = Loadable(lazy(() => import("../pages/Blog/Blog")));
const Category = Loadable(lazy(() => import("../pages/Blog/Category")));
const AddCategory = Loadable(lazy(() => import("../pages/Blog/AddCategory")));
const EditCategory = Loadable(lazy(() => import("../pages/Blog/EditCategory")));
const Comment = Loadable(lazy(() => import("../pages/Blog/Comment")));
const NewPost = Loadable(lazy(() => import("../pages/Blog/NewPost")));
const EditPost = Loadable(lazy(() => import("../pages/Blog/EditPost")));

// Login
const LoginForm = Loadable(lazy(() => import("../pages/Login/Login")));

// Forgot Password
const ForgotPass = Loadable(
  lazy(() => import("../pages/Login/ForgotPassword"))
);

// Reset Password
// const ResetPassword1 = Loadable(
//   lazy(() => import("../pages/Login/ResetPassword1"))
// );

// Invoice
const Invoice = Loadable(lazy(() => import("../pages/Invoice/Invoice")));

// Expense
const Expense = Loadable(lazy(() => import("../pages/Expense/Expense")));
const PageNotFound = Loadable(lazy(() => import("../pages/PageNotFound")));
const Unauthorized = Loadable(lazy(() => import("../pages/Unauthorized")));
const FormsList = Loadable(lazy(() => import("../pages/Forms/FormsList")));

const CareGiverPatientFormList = Loadable(
  lazy(() => import("../pages/CaregiverDasboard/PatientFormList"))
);

export const PATHS = [
  {
    local_url: "maindashboard",
    remote_url: "dashboard",
    component: <PageOne />,
  },
  {
    local_url: "insurancedashboard",
    remote_url: "insurancedashboard",
    component: <PageOne_insurance />,
  },
  {
    local_url: "patientdashboard",
    remote_url: "patientdashboard",
    component: <PageOne_patients />,
  },
  {
    local_url: "patientguardiandashboard",
    remote_url: "patientguardiandashboard",
    component: <PageOne_guardian />,
  },
  {
    local_url: "doctordashboard",
    remote_url: "doctordashboard",
    component: <PageOne_doctor />,
  },
  {
    local_url: "patientregistration",
    remote_url: "patientregistration",
    component: <PatientRegistration />,
  },
  {
    local_url: "patientregistration/addpatient",
    remote_url: "patientregistration/addpatient",
    component: <AddPatient />,
  },
  {
    local_url: "patientregistration/editingpatient",
    remote_url: "patientregistration/editingpatient",
    component: <EditingPatient />,
  },
  {
    local_url: "insurance",
    remote_url: "insurance",
    component: <Insurance />,
  },
  {
    local_url: "kaizen-xplore",
    remote_url: "kaizen-xplore",
    component: <KaizenExplore />,
  },
  {
    local_url: "cdss",
    remote_url: "cdss",
    component: <AdhdCdss />,
  },
  {
    local_url: "tbi",
    remote_url: "tbi",
    component: <TbiCdss />,
  },
  {
    local_url: "headache-cdss",
    remote_url: "headache-cdss",
    component: <HeadacheCdss />,
  },
  {
    local_url: "memory-cdss",
    remote_url: "memory-cdss",
    component: <MemoryCdss />,
  },
  {
    local_url: "chat",
    remote_url: "chat",
    component: <ChatScreen />,
  },
  {
    local_url: "concussion-prediction",
    remote_url: "concussion-prediction",
    component: <ConcussionPrediction />,
  },
  // {
  //   local_url: "insurance/personalinfo",
  //   remote_url: "insurance/personalinfo",
  //   component: <PersonalInfo />,
  // },
  {
    local_url: "forms/editassignedforms/:id",
    remote_url: "forms/editassignedforms",
    component: <EditAssignedForms />,
  },
  {
    local_url: "insurance/insuranceinformation1",
    remote_url: "insurance/insuranceinformation1",
    component: <InsuranceInformation1 />,
  },
  // {
  //   local_url: "insurance/editpersonalinfo",
  //   remote_url: "insurance/editpersonalinfo",
  //   component: <EditPersonalInfo />,
  // },
  // {
  //   local_url: "insurance/editinsuranceinfo",
  //   remote_url: "insurance/editinsuranceinfo",
  //   component: <EditInsuranceInfo />,
  // },
  {
    local_url: "validation",
    remote_url: "validation",
    component: <Insurance />,
  },
  {
    local_url: "insurance/editinsuranceinfo",
    remote_url: "insurance/editinsuranceinfo",
    component: <InsuranceStepper />,
  },
  {
    local_url: "insurance/editinsuranceinfo/:id",
    remote_url: "insurance/editinsuranceinfo",
    component: <InsuranceStepper />,
  },
  // {
  //   local_url: "patients",
  //   remote_url: "patients",
  //   component: <Patients />,
  // },
  {
    local_url: "patients",
    remote_url: "patients",
    component: <Patients_Careadmin />,
  },
  {
    local_url: "mypatients",
    remote_url: "mypatients",
    component: <Patients_Doctor />,
  },
  {
    local_url: "patients/patientsmainstepper",
    remote_url: "patients/patientsmainstepper",
    component: <PatientsMainStepper />,
  },
  {
    local_url: "patients/patientseditstepper",
    remote_url: "patients/patientseditstepper",
    component: <PatientsEditStepper />,
  },
  {
    local_url: "patients/edit",
    remote_url: "patients/edit",
    component: <PatientsEditStepper_Careadmin />,
  },
  {
    local_url: "mypatients/edit",
    remote_url: "mypatients/edit",
    component: <PatientsEditStepper_Doctor />,
  },
  {
    local_url: "patients/edit/:id",
    remote_url: "patients/edit",
    component: <PatientsEditStepper_Careadmin />,
  },
  {
    local_url: "patients/addpatient1",
    remote_url: "patients/addpatient1",
    component: <AddPatient1 />,
  },
  {
    local_url: "patients/patientinsuranceinfo",
    remote_url: "patients/patientinsuranceinfo",
    component: <PatientInsuranceInfo />,
  },
  {
    local_url: "patients/emergency",
    remote_url: "patients/emergency",
    component: <Emergency />,
  },
  {
    local_url: "patients/healthprovider",
    remote_url: "patients/healthprovider",
    component: <HealthProvider />,
  },
  {
    local_url: "patients/medications",
    remote_url: "patients/medications",
    component: <Medications />,
  },
  {
    local_url: "patients/prescriptions",
    remote_url: "patients/prescriptions",
    component: <Prescription />,
  },
  {
    local_url: "patients/nonprescriptions",
    remote_url: "patients/nonprescriptions",
    component: <NonPrescription />,
  },
  {
    local_url: "patients/hipaa",
    remote_url: "patients/hipaa",
    component: <Hipaa />,
  },
  {
    local_url: "patients/agreement",
    remote_url: "patients/agreement",
    component: <Agreement />,
  },
  {
    local_url: "patients/financial",
    remote_url: "patients/financial",
    component: <Financial />,
  },
  {
    local_url: "patients/consent",
    remote_url: "patients/consent",
    component: <Consent />,
  },
  {
    local_url: "patientmonitoring/questionnairesassignment",
    remote_url: "patientmonitoring/questionnairesassignment",
    component: <QuestionnairesAssignment />,
  },
  {
    local_url: "patientmonitoring/tmphistory",
    remote_url: "patientmonitoring/tmphistory",
    component: <TmpHistory />,
  },
  {
    local_url: "patientmonitoring/tmpgraph",
    remote_url: "patientmonitoring/tmpgraph",
    component: <TmpGraph />,
  },
  {
    local_url: "patientmonitoring/trmgraph",
    remote_url: "patientmonitoring/trmgraph",
    component: <TrmGraph />,
  },
  {
    local_url: "patientmonitoring/khpgraph",
    remote_url: "patientmonitoring/khpgraph",
    component: <KhpGraph />,
  },
  {
    local_url: "patientmonitoring/adhdgraph",
    remote_url: "patientmonitoring/adhdgraph",
    component: <AdhdGraph />,
  },
  {
    local_url: "patientmonitoring/saintgraph",
    remote_url: "patientmonitoring/saintgraph",
    component: <SaintGraph />,
  },
  {
    local_url: "patientmonitoring/kmpgraph",
    remote_url: "patientmonitoring/kmpgraph",
    component: <KmpGraph />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires",
    remote_url: "patientmonitoring/tmpquestionnaires",
    component: <TmpQuestionnaires />,
  },
  {
    local_url: "myhealthrecord/questionnaires",
    remote_url: "myhealthrecord/questionnaires",
    component: <PatientFormList />,
  },
  {
    local_url: "patient-healthrecord/questionnaires",
    remote_url: "patient-healthrecord/questionnaires",
    component: <CareGiverPatientFormList />,
  },
  {
    local_url: "myhealthrecord/questionnairesassignment",
    remote_url: "myhealthrecord/questionnairesassignment",
    component: <QuestionnairesAssignment />,
  },
  // {
  //   local_url: "patient-healthrecord/questionnairesassignment",
  //   remote_url: "patient-healthrecord/questionnairesassignment",
  //   component: <QuestionnairesAssignment />,
  // },
  {
    local_url: "myhealthrecord/myhistory",
    remote_url: "myhealthrecord/myhistory",
    component: <CompletedForms />,
  },
  {
    local_url: "patient-healthrecord/patient-history",
    remote_url: "patient-healthrecord/patient-history",
    component: <CaregiverCompletedForms />,
  },
  {
    local_url: "myhealthrecord/mygraphs",
    remote_url: "myhealthrecord/mygraphs",
    component: <TmpGraph />,
  },
  // {
  //   local_url: "patient-healthrecord/patient-graphs",
  //   remote_url: "patient-healthrecord/patient-graphs",
  //   component: <TmpGraph />,
  // },
  // {
  //   local_url: "myhealthrecord/questionnaires",
  //   remote_url: "myhealthrecord/questionnaires",
  //   component: <TmpQuestionnaires />,
  // },

  {
    local_url: "patientmonitoring/tmpquestionnaires/bdi",
    remote_url: "patientmonitoring/tmpquestionnaires/bdi",
    component: <BdiTmp />,
  },
  {
    local_url: "forms/bdi",
    remote_url: "forms/bdi",
    component: <Bdi />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/ciss",
    remote_url: "patientmonitoring/tmpquestionnaires/ciss",
    component: <CissTmp />,
  },
  {
    local_url: "forms/ciss",
    remote_url: "forms/ciss",
    component: <Ciss />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/ess",
    remote_url: "patientmonitoring/tmpquestionnaires/ess",
    component: <EssTmp />,
  },
  {
    local_url: "forms/ess",
    remote_url: "forms/ess",
    component: <Ess />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/hit",
    remote_url: "patientmonitoring/tmpquestionnaires/hit",
    component: <HitTmp />,
  },
  {
    local_url: "forms/hit",
    remote_url: "forms/hit",
    component: <Hit />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/lawton",
    remote_url: "patientmonitoring/tmpquestionnaires/lawton",
    component: <LawtonTmp />,
  },
  {
    local_url: "forms/lawton",
    remote_url: "forms/lawton",
    component: <Lawton />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/mb",
    remote_url: "patientmonitoring/tmpquestionnaires/mb",
    component: <MbTmp />,
  },
  {
    local_url: "forms/mb",
    remote_url: "forms/mb",
    component: <Mb />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/medical",
    remote_url: "patientmonitoring/tmpquestionnaires/medical",
    component: <MedicalTmp />,
  },
  {
    local_url: "forms/medical",
    remote_url: "forms/medical",
    component: <Medical />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/mna",
    remote_url: "patientmonitoring/tmpquestionnaires/mna",
    component: <MnaTmp />,
  },
  {
    local_url: "forms/mna",
    remote_url: "forms/mna",
    component: <Mna />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/nphq",
    remote_url: "patientmonitoring/tmpquestionnaires/nphq",
    component: <NphqTmp />,
  },
  {
    local_url: "forms/nphq",
    remote_url: "forms/nphq",
    component: <Nphq />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/npi",
    remote_url: "patientmonitoring/tmpquestionnaires/npi",
    component: <NpiTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/gad",
    remote_url: "patientmonitoring/tmpquestionnaires/gad",
    component: <GadTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/phq",
    remote_url: "patientmonitoring/tmpquestionnaires/phq",
    component: <PhqTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/qol",
    remote_url: "patientmonitoring/tmpquestionnaires/qol",
    component: <QolTmp />,
  },
  {
    local_url: "forms/npi",
    remote_url: "forms/npi",
    component: <Npi />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/phq",
    remote_url: "patientmonitoring/tmpquestionnaires/phq",
    component: <Phq />,
  },
  {
    local_url: "forms/phq",
    remote_url: "forms/phq",
    component: <Phq />,
  },
  {
    local_url: "forms/phqtrm",
    remote_url: "forms/phqtrm",
    component: <Phqtrm />,
  },
  {
    local_url: "form/view/phqtrm",
    remote_url: "form/view/phqtrm",
    component: <PhqtrmView />,
  },
  {
    local_url: "form/view/gadtrm",
    remote_url: "form/view/gadtrm",
    component: <GadtrmView />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/rpcstrm",
    remote_url: "patientmonitoring/tmpquestionnaires/rpcstrm",
    component: <RpcstrmTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/hittrm",
    remote_url: "patientmonitoring/tmpquestionnaires/hittrm",
    component: <HittrmTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/esstrm",
    remote_url: "patientmonitoring/tmpquestionnaires/esstrm",
    component: <EsstrmTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/cisstrm",
    remote_url: "patientmonitoring/tmpquestionnaires/cisstrm",
    component: <CisstrmTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/gadtrm",
    remote_url: "patientmonitoring/tmpquestionnaires/gadtrm",
    component: <GadtrmTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/phqtrm",
    remote_url: "patientmonitoring/tmpquestionnaires/phqtrm",
    component: <PhqtrmTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/rpcs",
    remote_url: "patientmonitoring/tmpquestionnaires/rpcs",
    component: <RpcsTmp />,
  },
  {
    local_url: "patientmonitoring/diagnosticreports",
    remote_url: "patientmonitoring/diagnosticreports",
    component: <DiagnosticUpload />,
  },
  {
    local_url: "patientmonitoring/diagnosticreports/view",
    remote_url: "patientmonitoring/diagnosticreports/view",
    component: <DiagnosticView />,
  },
  {
    local_url: "pendingforms",
    remote_url: "pendingforms",
    component: <PendingForms />,
  },
  {
    local_url: "allpatientvitals",
    remote_url: "allpatientvitals",
    component: <PatientVitals />,
  },
  {
    local_url: "addpatientvitals",
    remote_url: "addpatientvitals",
    component: <AddPatientVitals />,
  },
  {
    local_url: "myvitals",
    remote_url: "myvitals",
    component: <PatientVitalsLog />,
  },
  {
    local_url: "patient-vitals",
    remote_url: "patient-vitals",
    component: <CaregiverPatientVitalsLog />,
  },
  {
    local_url: "mypatientvitals",
    remote_url: "mypatientvitals",
    component: <PatientVitals_Doctor />,
  },
  {
    local_url: "addvitals",
    remote_url: "addvitals",
    component: <AddVitals />,
  },

  {
    local_url: "add-patient-vitals",
    remote_url: "add-patient-vitals",
    component: <CaregiverAddVitals />,
  },
  {
    local_url: "appointments",
    remote_url: "appointments",
    component: <Appointments />,
  },
  // {
  //   local_url: "appointments_doctor",
  //   remote_url: "appointments_doctor",
  //   component: <Appointments_Doctor />,
  // },
  {
    local_url: "appointments_doctor",
    remote_url: "appointments_doctor",
    component: <DoctorDashboard />,
  },
  // {
  //   local_url: "myappointments",
  //   remote_url: "myappointments",
  //   component: <Appointments_Patient />,
  // },
  {
    local_url: "myappointments",
    remote_url: "myappointments",
    component: <PatientAppointmentsPage />,
  },
  {
    local_url: "appointments/newappointment",
    remote_url: "appointments/newappointment",
    component: <NewAppointment />,
  },
  {
    local_url: "appointments/editappointment",
    remote_url: "appointments/editappointment",
    component: <EditAppointment />,
  },
  {
    local_url: "invoice",
    remote_url: "invoice",
    component: <Invoice />,
  },
  {
    local_url: "expense",
    remote_url: "expense",
    component: <Expense />,
  },
  {
    local_url: "careplan",
    remote_url: "careplan",
    component: <CarePlan />,
  },
  {
    local_url: "patientcareplan",
    remote_url: "patientcareplan",
    component: <CarePlan_Doctor />,
  },
  {
    local_url: "mycareplan",
    remote_url: "mycareplan",
    component: <CarePlan />,
  },
  {
    local_url: "careplan/newcareplan",
    remote_url: "careplan/newcareplan",
    component: <NewCarePlan />,
  },
  {
    local_url: "careplan/editcareplan",
    remote_url: "careplan/editcareplan",
    component: <EditCarePlan />,
  },
  {
    local_url: "patientcareplan/newcareplan_d",
    remote_url: "patientcareplan/newcareplan_d",
    component: <NewCarePlan_Doctor />,
  },
  {
    local_url: "patientcareplan/editcareplan_d",
    remote_url: "patientcareplan/editcareplan_d",
    component: <EditCarePlan_Doctor />,
  },
  {
    local_url: "departments",
    remote_url: "departments",
    component: <Departments />,
  },
  {
    local_url: "departments/newdepartments",
    remote_url: "departments/newdepartments",
    component: <NewDepartments />,
  },
  {
    local_url: "departments/editdepartments",
    remote_url: "departments/editdepartments",
    component: <EditDepartments />,
  },
  {
    local_url: "departments/editdepartments/:ids",
    remote_url: "departments/editdepartments",
    component: <EditDepartments />,
  },
  {
    local_url: "doctors",
    remote_url: "doctors",
    component: <Doctors />,
  },
  {
    local_url: "doctors/adddoctor",
    remote_url: "doctors/adddoctor",
    component: <AddDoctor />,
  },
  {
    local_url: "doctors/editdoctor",
    remote_url: "doctors/editdoctor",
    component: <EditDoctor />,
  },
  {
    local_url: "doctors/editdoctor/:id",
    remote_url: "doctors/editdoctor",
    component: <EditDocBasicinfo />,
  },
  {
    local_url: "user/users",
    remote_url: "user/users",
    component: <Users />,
  },
  {
    local_url: "user/adduser",
    remote_url: "user/adduser",
    component: <AddUser />,
  },
  {
    local_url: "user/edituser",
    remote_url: "user/edituser",
    component: <EditUser />,
  },
  {
    local_url: "user/listofpassword",
    remote_url: "user/listofpassword",
    component: <ListOfPassword />,
  },
  {
    local_url: "user/editlistofpassword",
    remote_url: "user/editlistofpassword",
    component: <EditListOfPassword />,
  },
  {
    local_url: "report-issue",
    remote_url: "report-issue",
    component: <ReportIssue />,
  },
  {
    local_url: "edit-issue-status",
    remote_url: "edit-issue-status",
    component: <ReportIssueEdit />,
  },
  {
    local_url: "view-issue-status",
    remote_url: "view-issue-status",
    component: <ReportIssueView />,
  },
  {
    local_url: "developerdashboard",
    remote_url: "developerdashboard",
    component: <ReportNotification />,
  },
  {
    local_url: "user/userrole",
    remote_url: "user/userrole",
    component: <UserRole />,
  },
  {
    local_url: "user/newuserrole",
    remote_url: "user/newuserrole",
    component: <NewUserRole />,
  },
  {
    local_url: "user/edituserrole",
    remote_url: "user/edituserrole",
    component: <EditUserRole />,
  },
  {
    local_url: "email/sendemail",
    remote_url: "email/sendemail",
    component: <SendEmail />,
  },
  {
    local_url: "email/sendbulkemail",
    remote_url: "email/sendbulkemail",
    component: <SendBulkEmail />,
  },
  {
    local_url: "email/emaillog",
    remote_url: "email/emaillog",
    component: <EmailLog />,
  },
  {
    local_url: "email/emailsettings",
    remote_url: "email/emailsettings",
    component: <EmailSettings />,
  },
  {
    local_url: "email/emailtemplate",
    remote_url: "email/emailtemplate",
    component: <EmailTemplate />,
  },
  {
    local_url: "email/emailtemplate",
    remote_url: "email/emailtemplate",
    component: <EmailTemplate />,
  },
  {
    local_url: "blog/blogs",
    remote_url: "blog/blogs",
    component: <Blog />,
  },
  {
    local_url: "blog/category",
    remote_url: "blog/category",
    component: <Category />,
  },
  {
    local_url: "blog/addcategory",
    remote_url: "blog/addcategory",
    component: <AddCategory />,
  },
  {
    local_url: "blog/editcategory",
    remote_url: "blog/editcategory",
    component: <EditCategory />,
  },
  {
    local_url: "blog/comment",
    remote_url: "blog/comment",
    component: <Comment />,
  },
  {
    local_url: "blog/newpost",
    remote_url: "blog/newpost",
    component: <NewPost />,
  },
  {
    local_url: "blog/editpost",
    remote_url: "blog/editpost",
    component: <EditPost />,
  },
  {
    local_url: "forms/allforms",
    remote_url: "forms/allforms",
    component: <Forms />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/katz",
    remote_url: "patientmonitoring/tmpquestionnaires/katz",
    component: <ActivitiesFormTmp />,
  },
  {
    local_url: "forms/katz",
    remote_url: "forms/katz",
    component: <ActivitiesForm />,
  },

  {
    local_url: "patientmonitoring/tmpquestionnaires/adhd",
    remote_url: "patientmonitoring/tmpquestionnaires/adhd",
    component: <AdhdTmp />,
  },
  {
    local_url: "forms/adhd",
    remote_url: "forms/adhd",
    component: <Adhd />,
  },
  {
    local_url: "forms/assignforms",
    remote_url: "forms/assignforms",
    component: <AssignForms />,
  },
  {
    local_url: "forms/editassignedforms",
    remote_url: "forms/editassignedforms",
    component: <EditAssignedForms />,
  },
  {
    local_url: "forms/formslist",
    remote_url: "forms/formslist",
    component: <FormsList />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/caic",
    remote_url: "patientmonitoring/tmpquestionnaires/caic",
    component: <CaicTmp />,
  },
  {
    local_url: "forms/caic",
    remote_url: "forms/caic",
    component: <Caic />,
  },
  {
    local_url: "forms/cpcr",
    remote_url: "forms/cpcr",
    component: <Cpcr />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/cpcr",
    remote_url: "patientmonitoring/tmpquestionnaires/cpcr",
    component: <CpcrTmp />,
  },
  {
    local_url: "facialpain/facialPain",
    remote_url: "facialpain/facialPain",
    component: <FacialPain />,
  },

  {
    local_url: "patientmonitoring/tmpquestionnaires/fpq",
    remote_url: "patientmonitoring/tmpquestionnaires/fpq",
    component: <FpqTmp />,
  },
  {
    local_url: "forms/fpq",
    remote_url: "forms/fpq",
    component: <FacialPain />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/gad",
    remote_url: "patientmonitoring/tmpquestionnaires/gad",
    component: <Gad />,
  },
  {
    local_url: "forms/gad",
    remote_url: "forms/gad",
    component: <Gad />,
  },
  {
    local_url: "forms/gadtrm",
    remote_url: "forms/gadtrm",
    component: <Gadtrm />,
  },
  {
    local_url: "forms/rpcstrm",
    remote_url: "forms/rpcstrm",
    component: <Rpcstrm />,
  },
  {
    local_url: "forms/hittrm",
    remote_url: "forms/hittrm",
    component: <Hittrm />,
  },
  {
    local_url: "forms/esstrm",
    remote_url: "forms/esstrm",
    component: <Esstrm />,
  },
  {
    local_url: "forms/cisstrm",
    remote_url: "forms/cisstrm",
    component: <Cisstrm />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/qol",
    remote_url: "patientmonitoring/tmpquestionnaires/qol",
    component: <StigmaForm />,
  },
  {
    local_url: "forms/qol",
    remote_url: "forms/qol",
    component: <StigmaForm />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/sunshineact",
    remote_url: "patientmonitoring/tmpquestionnaires/sunshineact",
    component: <SunshineTmp />,
  },
  {
    local_url: "forms/sunshine",
    remote_url: "forms/sunshine",
    component: <SunshineAct />,
  },
  // {
  //   local_url: "forms/neuroconsent",
  //   remote_url: "forms/neuroconsent",
  //   component: <NeuroConsent />,
  // },

  {
    local_url: "patientmonitoring/tmpquestionnaires/icna",
    remote_url: "patientmonitoring/tmpquestionnaires/icna",
    component: <IcnaTmp />,
  },
  {
    local_url: "forms/icna",
    remote_url: "forms/icna",
    component: <NeuroConsent />,
  },
  {
    local_url: "forms/rpcs",
    remote_url: "forms/rpcs",
    component: <Rpcs />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/hipaarf",
    remote_url: "patientmonitoring/tmpquestionnaires/hipaarf",
    component: <HipaaRfTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/hipaanpp",
    remote_url: "patientmonitoring/tmpquestionnaires/hipaanpp",
    component: <HipaaNppTmp />,
  },
  {
    local_url: "forms/hipaarf",
    remote_url: "forms/hipaarf",
    component: <Hipaa2 />,
  },
  {
    local_url: "forms/hipaanpp",
    remote_url: "forms/hipaanpp",
    component: <HipaaNP />,
  },
  {
    local_url: "forms/newform",
    remote_url: "forms/newform",
    component: <NewForm />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/drfox",
    remote_url: "patientmonitoring/tmpquestionnaires/drfox",
    component: <DrFox />,
  },
  //patientmonitoring/tmpquestionnaires/
  {
    local_url: "patientmonitoring/tmpquestionnaires/rphf",
    remote_url: "patientmonitoring/tmpquestionnaires/rphf",
    component: <DrFox />,
  },
  {
    local_url: "forms/rphf",
    remote_url: "forms/rphf",
    component: <DrFox />,
  },
  // Patients

  //  {
  //   local_url: "myprofile",
  //   remote_url: "myprofile",
  //   component: <MyProfile />,
  // },
  {
    local_url: "myprofile",
    remote_url: "myprofile",
    component: <MyProfile />,
  },
  {
    local_url: "patient-profile",
    remote_url: "patient-profile",
    component: <CaregiverPatientProfile />,
  },
  {
    local_url: "patients/view",
    remote_url: "patients/view",
    component: <MyProfileCareadmin />,
  },
  {
    local_url: "mypatients/view",
    remote_url: "mypatients/view",
    component: <MyProfileDoctor />,
  },
  {
    local_url: "patients/view/:id",
    remote_url: "patients/view",
    component: <MyProfileCareadmin />,
  },
  {
    local_url: "myprofile/editinfo",
    remote_url: "myprofile/editinfo",
    component: <PatientsEditStepper />,
  },
  {
    local_url: "patient-profile/editinfo",
    remote_url: "patient-profile/editinfo",
    component: <CaregiverPatientsEditStepper />,
  },
  {
    local_url: "myprofile/editinfo/:id",
    remote_url: "myprofile/editinfo/:id",
    component: <PatientsEditStepper />,
  },
  {
    local_url: "patient-profile/editinfo/:id",
    remote_url: "patient-myprofile/editinfo/:id",
    component: <CaregiverPatientsEditStepper />,
  },
  {
    local_url: "patientprofile",
    remote_url: "patientprofile",
    component: <PatientProfile />,
  },
  {
    local_url: "form/view/rpcs",
    remote_url: "form/view/rpcs",
    component: <RpcsView />,
  },
  {
    local_url: "form/view/hit",
    remote_url: "form/view/hit",
    component: <HitView />,
  },
  {
    local_url: "form/view/stress",
    remote_url: "form/view/stress",
    component: <StressView />,
  },
  {
    local_url: "form/view/npio",
    remote_url: "form/view/npio",
    component: <NpioView />,
  },
  {
    local_url: "form/view/dsrs",
    remote_url: "form/view/dsrs",
    component: <DsrsView />,
  },
  {
    local_url: "form/view/safety",
    remote_url: "form/view/safety",
    component: <SafetyView />,
  },
  {
    local_url: "form/view/faq",
    remote_url: "form/view/faq",
    component: <FaqView />,
  },
  {
    local_url: "form/view/nasa",
    remote_url: "form/view/nasa",
    component: <NasaView />,
  },
  {
    local_url: "form/view/bdi",
    remote_url: "form/view/bdi",
    component: <BdiView />,
  },
  {
    local_url: "form/view/npi",
    remote_url: "form/view/npi",
    component: <NpiView />,
  },
  {
    local_url: "form/view/ess",
    remote_url: "form/view/ess",
    component: <EssView />,
  },
  {
    local_url: "form/view/ciss",
    remote_url: "form/view/ciss",
    component: <CissView />,
  },
  {
    local_url: "form/view/medical",
    remote_url: "form/view/medical",
    component: <MedicalView />,
  },
  {
    local_url: "form/view/phq",
    remote_url: "form/view/phq",
    component: <PhqView />,
  },
  {
    local_url: "form/view/nphq",
    remote_url: "form/view/nphq",
    component: <NphqView />,
  },
  {
    local_url: "form/view/gad",
    remote_url: "form/view/gad",
    component: <GadView />,
  },
  {
    local_url: "form/view/mna",
    remote_url: "form/view/mna",
    component: <MnaView />,
  },
  {
    local_url: "form/view/mb",
    remote_url: "form/view/mb",
    component: <MbView />,
  },
  {
    local_url: "form/view/lawton",
    remote_url: "form/view/lawton",
    component: <LawtonView />,
  },
  {
    local_url: "form/view/facialpain",
    remote_url: "form/view/facialpain",
    component: <FacialPainView />,
  },
  {
    local_url: "form/view/adhd",
    remote_url: "form/view/adhd",
    component: <AdhdView />,
  },
  {
    local_url: "form/view/hipaarf",
    remote_url: "form/view/hipaarf",
    component: <HippaView />,
  },
  {
    local_url: "form/view/hipaanpp",
    remote_url: "form/view/hipaanpp",
    component: <HipaaNppView />,
  },
  {
    local_url: "form/view/sunshineact",
    remote_url: "form/view/sunshineact",
    component: <SunshineAct />,
  },
  {
    local_url: "form/view/neuro",
    remote_url: "form/view/neuro",
    component: <NeuroConsentView />,
  },
  {
    local_url: "form/view/cpcr",
    remote_url: "form/view/cpcr",
    component: <CpcrView />,
  },
  {
    local_url: "form/view/caic",
    remote_url: "form/view/caic",
    component: <CaicView />,
  },
  {
    local_url: "form/view/katz",
    remote_url: "form/view/katz",
    component: <ActivitiesFormView />,
  },
  {
    local_url: "form/view/qol",
    remote_url: "form/view/qol",
    component: <StigmaFormView />,
  },
  {
    local_url: "form/view/drfox",
    remote_url: "form/view/drfox",
    component: <DrFoxView />,
  },

  {
    local_url: "profilecover",
    remote_url: "profilecover",
    component: <ProfileCover />,
  },

  // {
  //   local_url: "myvitals",
  //   remote_url: "myvitals",
  //   component: <MyVitals />,
  // },
  // {
  //   local_url: "myappointments",
  //   remote_url: "myappointments",
  //   component: <My Appointments />,
  // },
  {
    local_url: "programs",
    remote_url: "programs",
    component: <AssignProgram />,
  },
  {
    local_url: "newprogram",
    remote_url: "newprogram",
    component: <AddPrograms />,
  },
  {
    local_url: "programforms",
    remote_url: "programforms",
    component: <ProgramForms />,
  },
  {
    local_url: "editprogramforms",
    remote_url: "editprogramforms",
    component: <EditProgram />,
  },
  {
    local_url: "programlist",
    remote_url: "programlist",
    component: <NewProgram />,
  },
  {
    local_url: "forms/pcl",
    remote_url: "forms/pcl",
    component: <Pcl />,
  },
  {
    local_url: "forms/odq",
    remote_url: "forms/odq",
    component: <OxfordForm />,
  },
  {
    local_url: "forms/neuroqol",
    remote_url: "forms/neuroqol",
    component: <NeuroQol />,
  },
  {
    local_url: "form/view/odq",
    remote_url: "form/view/odq",
    component: <OxfordView />,
  },
  {
    local_url: "form/view/pcl",
    remote_url: "form/view/pcl",
    component: <PclView />,
  },
  {
    local_url: "form/view/neuroqol",
    remote_url: "form/view/neuroqol",
    component: <NeuroQolView />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/odq",
    remote_url: "patientmonitoring/tmpquestionnaires/odq",
    component: <OxfordTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/pcl",
    remote_url: "patientmonitoring/tmpquestionnaires/pcl",
    component: <PclTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/neuroqol",
    remote_url: "patientmonitoring/tmpquestionnaires/neuroqol",
    component: <NeuroQolTmp />,
  },
  {
    local_url: "myhealthrecord/hamp",
    remote_url: "myhealthrecord/hamp",
    component: <HampInsert />,
  },
  {
    local_url: "hamp/view",
    remote_url: "hamp/view",
    component: <HampView />,
  },
  {
    local_url: "activitylog",
    remote_url: "activitylog",
    component: <ActivityLog />,
  },
  {
    local_url: "forms/safety",
    remote_url: "forms/safety",
    component: <Safety />,
  },
  {
    local_url: "forms/faq",
    remote_url: "forms/faq",
    component: <Faq />,
  },
  {
    local_url: "forms/nasa",
    remote_url: "forms/nasa",
    component: <Nasa />,
  },
  {
    local_url: "forms/stress",
    remote_url: "forms/stress",
    component: <StressMeter />,
  },
  {
    local_url: "forms/dsrs",
    remote_url: "forms/dsrs",
    component: <DsrsForm />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/dsrs",
    remote_url: "patientmonitoring/tmpquestionnaires/dsrs",
    component: <DsrsFormTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/safety",
    remote_url: "patientmonitoring/tmpquestionnaires/safety",
    component: <SafetyTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/faq",
    remote_url: "patientmonitoring/tmpquestionnaires/faq",
    component: <FaqTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/nasa",
    remote_url: "patientmonitoring/tmpquestionnaires/nasa",
    component: <NasaTmp />,
  },
  {
    local_url: "patientmonitoring/tmpquestionnaires/stress",
    remote_url: "patientmonitoring/tmpquestionnaires/stress",
    component: <StressMeterTmp />,
  },
  {
    local_url: "form/view/rpcstrm",
    remote_url: "form/view/rpcstrm",
    component: <RpcstrmView />,
  },
  {
    local_url: "form/view/hittrm",
    remote_url: "form/view/hittrm",
    component: <HittrmView />,
  },
  {
    local_url: "form/view/esstrm",
    remote_url: "form/view/esstrm",
    component: <EsstrmView />,
  },
  {
    local_url: "form/view/cisstrm",
    remote_url: "form/view/cisstrm",
    component: <CisstrmView />,
  },
  //PHQ8
  {
    local_url: "patientmonitoring/tmpquestionnaires/phq8",
    remote_url: "patientmonitoring/tmpquestionnaires/phq8",
    component: <Phq8Tmp />,
  },
  {
    local_url: "forms/phq8",
    remote_url: "forms/phq8",
    component: <Phq8 />,
  },
  {
    local_url: "form/view/phq8",
    remote_url: "form/view/phq8",
    component: <Phq8View />,
  },
];

// for navbar menu items
export function navBarItems(List) {
  return (
    List.length > 0 &&
    PATHS.filter((path) => List.includes(path.remote_url)).map(
      (path) => path.local_url
    )
  );
}
